module.exports = __webpack_public_path__ + "static/media/noun-car-5226133-142350.68ae6229.svg";